module.exports = __webpack_public_path__ + "img/ja-jp.a34af73c.svg";